import i18n from '@/i18n';
const STATUS = {
    agendada: {
        key: 'agendada',
        label: i18n.global.t('breadcrumb.email.campaigns.table.status-labels.agendada'),
        dotColor: '#F1C40F',
        tip: 'breadcrumb.email.campaigns.table.tooltip.scheduled',
    },
    enviando: {
        key: 'enviando',
        label: i18n.global.t('breadcrumb.email.campaigns.table.status-labels.enviando'),
        dotColor: '#6C90F4',
        tip: 'breadcrumb.email.campaigns.table.tooltip.sending',
    },
    concluída: {
        key: 'concluída',
        label: i18n.global.t('breadcrumb.email.campaigns.table.status-labels.concluida'),
        dotColor: '#2ECC71',
        tip: 'breadcrumb.email.campaigns.table.tooltip.completed',
    },
    falha: {
        key: 'falha',
        label: i18n.global.t('breadcrumb.email.campaigns.table.status-labels.falha'),
        dotColor: '#E74C3C',
        tip: 'breadcrumb.email.campaigns.table.tooltip.failed',
    },
    encerrada: {
        key: 'encerrada',
        label: i18n.global.t('breadcrumb.email.campaigns.table.status-labels.encerrada'),
        dotColor: '#B3B3B3',
        tip: 'breadcrumb.email.campaigns.table.tooltip.closed',
    },
    rascunho: {
        key: 'rascunho',
        label: i18n.global.t('breadcrumb.email.campaigns.table.status-labels.rascunho'),
        dotColor: '#B3B3B3',
        tip: 'breadcrumb.email.campaigns.table.tooltip.draft',
    },
};
export function getCampaignStatus(status) {
    if (!status)
        return STATUS.rascunho;
    const key = status.toString().trim().toLowerCase();
    return STATUS[key] ?? STATUS.rascunho;
}
